<template>
  <div class="charts-two-blocks-container" style="background: #f1f5f9; margin-bottom: 10px">
    <div class="sentiment-container">
      <div class="sentiment-chart-header">
        <span class="card-title" style="margin-bottom: 10px">Avaliações</span>
      </div>
      <CustomSkeleton v-if="isLoadingAllData" type="card" />

      <div
        v-for="review in reviews.airport"
        class="sentiment-card"
        style="padding: 16px 24px 16px 24px"
        :key="review.id"
      >
        <span class="sentiment-card-title">Modal Aeroviário</span>

        <CustomSkeleton v-if="isLoadingAllData" type="card" />
        <span class="sentiment-card-subtitle">{{ review.formatted_address || review.name }}</span>
        <div class="sentiment-card-content">
          <div class="sentiment-card-content-left">
            <img src="/review-shop.svg" alt="Avaliação" />
            <div class="sentiment-card-content-left-review">
              <span class="sentiment-card-content-text-review">
                <i class="fa-solid fa-star"></i>{{ review.rating }}</span
              >
              <span class="sentiment-card-content-text-total"
                >{{ review.review_count }} avaliações</span
              >
              <!-- <ReviewProgressBar :reviews="review.reviews.map((r) => r.rating)" /> -->
            </div>
          </div>
          <div style="display: flex; flex-direction: column; text-align: center">
            <span style="font-size: 0.75rem; font-weight: 400; color: #545f65"
              >Sentimento geral:</span
            >
            <CustomSkeleton v-if="isLoadingAllData" type="card" />
            <span
              :style="{ color: parseSentimentColor(review.rating) }"
              style="font-size: 12px; font-weight: 600"
              ><font-awesome-icon
                :icon="parseSentimentIcon(review.rating)"
                style="margin-right: 7px; margin-top: 6px"
                size="lg"
              />{{ parseSentiment(review.rating) }}</span
            >
          </div>
        </div>
      </div>
      <div
        v-if="!isLoadingAllData"
        v-for="review in reviews.busStation"
        class="sentiment-card"
        style="padding: 16px 24px 16px 24px"
        :key="review.id"
      >
        <span class="sentiment-card-title">Modal Rodoviário</span>
        <span class="sentiment-card-subtitle">{{ review.formatted_address || review.name }}</span>
        <div class="sentiment-card-content">
          <div class="sentiment-card-content-left">
            <img src="/review-shop.svg" alt="Avaliação" />
            <div class="sentiment-card-content-left-review">
              <span class="sentiment-card-content-text-review">
                <i class="fa-solid fa-star"></i>{{ review.rating }}</span
              >
              <span class="sentiment-card-content-text-total"
                >{{ review.review_count }} avaliações</span
              >
              <!-- <ReviewProgressBar :reviews="review.reviews.map((r) => r.rating)" /> -->
            </div>
          </div>
          <div style="display: flex; flex-direction: column; text-align: center">
            <span style="font-size: 0.75rem; font-weight: 400; color: #545f65"
              >Sentimento geral:</span
            >
            <span
              :style="{ color: parseSentimentColor(review.rating) }"
              style="font-size: 12px; font-weight: 600"
              ><font-awesome-icon
                :icon="parseSentimentIcon(review.rating)"
                style="margin-right: 7px; margin-top: 6px"
                size="lg"
              />{{ parseSentiment(review.rating) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="sentiment-container">
      <div
        class="sentiment-chart-header"
        :style="{ 'flex-direction': isLoadingAllData && 'column' }"
      >
        <span class="card-title">Sentimento</span>
        <CustomSkeleton v-if="isLoadingAllData" type="card" />
      </div>
      <div>
        <p v-if="!isLoadingAllData" class="card-subtitle" style="margin-top: 20px">
          {{ predominantSentimentText }}
        </p>
        <p v-if="!isLoadingAllData" class="card-text" style="text-align: left">
          É o sentimento de {{ predominantSentimentPercentage }}% das avaliações de modais
        </p>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <canvas id="sentiment-chart" class="sentiment-chart"></canvas>
          <div class="chart-custom-legend-container" style="margin: 10px 0">
            <CustomLegend color="#0B8C0B" text="Positivo" />
            <CustomLegend color="#FFC700" text="Neutro" />
            <CustomLegend color="#F25362" text="Negativo" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLegend from '@/Shared/Charts/CustomLegend'
import CustomSkeleton from '@/Shared/CustomSkeleton.vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default {
  name: 'Reviews',
  components: {
    CustomLegend,
    CustomSkeleton,
  },
  props: {
    reviews: {
      type: Object,
      required: true,
    },
    isLoadingAllData: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      modesSentimentChart: [
        { label: 'Aeroviário', value: 'Aeroviário' },
        { label: 'Rodoviário', value: 'Rodoviário' },
      ],
      selectedModesSentimentChart: [],
      sentimentData: {
        positive: 0,
        neutral: 0,
        negative: 0,
        total: 0,
      },
      predominantSentimentText: '',
      predominantSentimentPercentage: 0,
      sentimentChart: null,
    }
  },
  watch: {
    reviews: {
      immediate: true,
      handler(newVal) {
        if (newVal.busStation && newVal.airport) {
          this.calculateSentimentData()
          this.createSentimentChart()
        }
      },
    },
    isLoadingAllData(newVal) {
      if (!newVal && this.reviews.busStation && this.reviews.airport) {
        this.calculateSentimentData()
        this.createSentimentChart()
      }
    },
  },
  methods: {
    handleChange(selectedModes) {
      console.log('Modos de transporte selecionados:', selectedModes)
    },

    calculateSentimentData() {
      const busStationReviews = this.reviews.busStation || []
      const airportReviews = this.reviews.airport || []
      const allRatings = [...busStationReviews, ...airportReviews].map((review) => review.rating)
      const sentimentCounts = allRatings.reduce(
        (counts, rating) => {
          if (rating < 2) counts.negative++
          else if (rating >= 3 && rating < 4) counts.neutral++
          else if (rating >= 4) counts.positive++
          return counts
        },
        { negative: 0, neutral: 0, positive: 0 },
      )
      const totalReviews = allRatings.length
      this.sentimentData = { ...sentimentCounts, total: totalReviews }

      if (
        sentimentCounts.positive >= sentimentCounts.neutral &&
        sentimentCounts.positive >= sentimentCounts.negative
      ) {
        this.predominantSentimentText = 'Positivo'
        this.predominantSentimentPercentage = (
          (sentimentCounts.positive / totalReviews) *
          100
        ).toFixed(2)
      } else if (
        sentimentCounts.neutral >= sentimentCounts.positive &&
        sentimentCounts.neutral >= sentimentCounts.negative
      ) {
        this.predominantSentimentText = 'Neutro'
        this.predominantSentimentPercentage = (
          (sentimentCounts.neutral / totalReviews) *
          100
        ).toFixed(2)
      } else {
        this.predominantSentimentText = 'Negativo'
        this.predominantSentimentPercentage = (
          (sentimentCounts.negative / totalReviews) *
          100
        ).toFixed(2)
      }
    },

    createSentimentChart() {
      const canvas = document.getElementById('sentiment-chart')
      const ctx = canvas.getContext('2d')
      if (this.sentimentChart) {
        this.sentimentChart.destroy()
      }
      this.sentimentChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Positivo', 'Neutro', 'Negativo'],
          datasets: [
            {
              data: [
                this.sentimentData.positive,
                this.sentimentData.neutral,
                this.sentimentData.negative,
              ],
              backgroundColor: ['#0B8C0B', '#FFC700', '#F25362'],
            },
          ],
        },

        options: {
          responsive: true,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              enabled: true,
              intersect: true,
              callbacks: {
                label: function (context) {
                  return `${context.dataset.data[context.dataIndex]}`
                },
              },
            },
          },
        },
      })
    },
    parseSentiment(rating) {
      if (rating < 2) {
        return 'Negativo'
      }
      if (rating >= 4) {
        return 'Positivo'
      }
      return 'Neutro'
    },
    parseSentimentIcon(rating) {
      if (rating < 2) {
        return 'fa-regular fa-face-tired'
      }
      if (rating >= 4) {
        return 'fa-regular fa-face-meh'
      }
      return 'fa-regular fa-face-smile'
    },
    parseSentimentColor(rating) {
      if (rating < 2) {
        return '#F25362'
      }
      if (rating >= 4) {
        return '#0B8C0B'
      }
      return '#FFC700'
    },
  },
}
</script>

<style src="./styles.css"></style>
